import { render, staticRenderFns } from "./SideMenuComponent.vue?vue&type=template&id=f93ce8f0"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./SideMenuComponent.vue?vue&type=style&index=0&id=f93ce8f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports